export const mobileQuery = '(max-width:600px)';
export const muiMobileQuery = '(max-width:768px)';
export const tabletQuery = '(max-width:860px)';
